import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxurycaronrentforweddinginpune() {



  const cardData =
  {
    keyword: 'Luxury Car on Rent for Wedding in Pune',
    heading: 'Sanavi Travels: Luxury Car on Rent for Wedding in Pune',
    headingDescription: 'Sanavi Travels offers premium Luxury Car on Rent for Wedding in Pune, providing elegant, stylish, and comfortable transportation for bridal entry, groom arrival, family members, and VIP guests on special wedding occasions. Our fleet of luxury sedans and premium cars is well-maintained, beautifully presented, and driven by professional, well-groomed chauffeurs, ensuring a royal and memorable wedding experience. With flexible hourly and full-day wedding car rental packages, transparent pricing, on-time service, and 24/7 booking support, Sanavi Travels guarantees punctual, hassle-free, and classy transportation. We provide luxury wedding car rentals across Pune including Kothrud, Baner, Wakad, Hinjewadi, Viman Nagar, Hadapsar, Pimpri-Chinchwad, and Pune city, making your special day truly unforgettable. Choose Sanavi Travels for trusted luxury wedding car rentals in Pune, delivering elegance, comfort, and exceptional service.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s most iconic historical landmark, built in 1732 by the Peshwas of the Maratha Empire. Once the seat of Peshwa administration, it features massive stone walls, grand gates like the Delhi Darwaza, and spacious courtyards. Although partially destroyed by fire, its remains reflect Maratha valor and heritage. The evening light-and-sound show brings Pune’s glorious past to life."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a significant monument linked to India’s freedom movement. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it houses a museum displaying photographs, letters, and personal belongings of Gandhi, set amidst serene gardens."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered Ganesh temple. The idol is adorned with gold ornaments and attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations and cultural events."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fort near Pune, famous for the heroic sacrifice of Tanaji Malusare. Visitors can trek or drive up to the fort to enjoy breathtaking views of the Sahyadri ranges. The fort is popular for trekking, history exploration, and traditional Maharashtrian food."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars and a peaceful sanctum. Despite being in a busy area, the temple offers a calm spiritual experience."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts showcasing India’s cultural heritage. The collection includes musical instruments, sculptures, utensils, and ornaments. The recreated Mastani Mahal is a major highlight for visitors."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic views of the city after climbing 103 stone steps. The Parvati Temple complex, built during the Peshwa era, is dedicated to Lord Shiva and Goddess Parvati and is especially popular during sunrise and sunset."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort attracts visitors from across the globe. It offers meditation programs, wellness therapies, and tranquil gardens, making it a center for peace, relaxation, and spiritual growth."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. With bridges, water streams, and manicured lawns, it is ideal for morning walks, family outings, photography, and peaceful relaxation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular leisure destination near Pune, especially during the monsoon season. The scenic reservoir, surrounding hills, and cool breeze make it a favorite spot for evening outings and weekend picnics. It also serves as the gateway to Sinhagad Fort."
  }
]
,




 "services": [
  {
    "name": "Luxury Car on Rent for Wedding in Pune",
    "description": "Luxury Car on Rent for Wedding in Pune offers premium vehicles for wedding occasions. Well-maintained, air-conditioned cars ensure a stylish and comfortable ride."
  },
  {
    "name": "Wedding Luxury Car Pune",
    "description": "Wedding Luxury Car Pune provides elegant cars for weddings, with professional chauffeurs ensuring punctual and smooth travel."
  },
  {
    "name": "Luxury Wedding Cab Pune",
    "description": "Luxury Wedding Cab Pune delivers top-end vehicles for wedding events, focusing on comfort, style, and timely service."
  },
  {
    "name": "Bridal Car Rental Pune",
    "description": "Bridal Car Rental Pune offers luxury cars specially arranged for brides, with experienced drivers ensuring a seamless wedding journey."
  },
  {
    "name": "Premium Car Hire Pune",
    "description": "Premium Car Hire Pune provides high-end vehicles for weddings and special events, combining elegance, comfort, and reliability."
  },
  {
    "name": "Chauffeur Driven Luxury Car",
    "description": "Chauffeur Driven Luxury Car offers professional drivers with luxury vehicles, ensuring a stress-free and stylish wedding travel experience."
  },
  {
    "name": "Best Wedding Car Pune",
    "description": "Best Wedding Car Pune ensures top-quality luxury cars for weddings, emphasizing comfort, style, and punctual service."
  },
  {
    "name": "Pune Wedding Car Booking",
    "description": "Pune Wedding Car Booking allows easy reservations for luxury wedding cars with professional chauffeurs for smooth travel."
  },
  {
    "name": "BMW Audi Car Rental Pune",
    "description": "BMW Audi Car Rental Pune offers premium German cars for weddings and events, ensuring a classy and comfortable journey."
  },
  {
    "name": "Luxury Car for Marriage Pune",
    "description": "Luxury Car for Marriage Pune provides stylish, well-maintained cars for weddings, offering comfort and elegance for the special day."
  },
  {
    "name": "Event Luxury Car Pune",
    "description": "Event Luxury Car Pune delivers high-end vehicles for weddings and other celebrations, prioritizing luxury, safety, and comfort."
  },
  {
    "name": "Affordable Luxury Car Pune",
    "description": "Affordable Luxury Car Pune offers budget-friendly luxury cars for weddings, maintaining comfort and style without high costs."
  },
  {
    "name": "Wedding Transport Cab Pune",
    "description": "Wedding Transport Cab Pune provides organized transportation for wedding events, with experienced drivers ensuring timely arrivals."
  },
  {
    "name": "VIP Wedding Car Pune",
    "description": "VIP Wedding Car Pune offers premium cars and personalized chauffeur service for VIP weddings, ensuring a luxurious travel experience."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking Pune enables easy booking of luxury wedding cars online with instant confirmation and reliable service."
  }
],
"tableData": [
  ["Luxury Car on Rent for Wedding in Pune", "Wedding Luxury Car Pune"],
  ["Luxury Wedding Cab Pune", "Bridal Car Rental Pune"],
  ["Premium Car Hire Pune", "Chauffeur Driven Luxury Car"],
  ["Best Wedding Car Pune", "Pune Wedding Car Booking"],
  ["BMW Audi Car Rental Pune", "Luxury Car for Marriage Pune"],
  ["Event Luxury Car Pune", "Affordable Luxury Car Pune"],
  ["Wedding Transport Cab Pune", "VIP Wedding Car Pune"],
  ["Online Cab Booking Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Luxury Car on Rent for Wedding in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers premium luxury car rental services for weddings in Pune, perfect for groom entry, bridal arrival, family transportation, and special wedding moments."
  },
  {
    "WhyChooseheading": "Wide Range of Luxury Cars",
    "WhyChoosedescription": "Choose from a curated fleet of luxury vehicles including Mercedes, BMW, Audi, and other premium cars to make your wedding grand and memorable."
  },
  {
    "WhyChooseheading": "Well-Maintained and Stylish Vehicles",
    "WhyChoosedescription": "Our luxury cars are regularly serviced, polished, and maintained to ensure a flawless and elegant appearance on your special day."
  },
  {
    "WhyChooseheading": "Professional and Uniformed Chauffeurs",
    "WhyChoosedescription": "Experience courteous and trained chauffeurs who provide punctual, respectful, and professional service throughout your wedding events."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Sanavi Travels offers customizable luxury car rental packages for weddings, including hourly, half-day, full-day, and multi-day options."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Get clear pricing with no hidden fees, inclusive of driver charges, fuel, and service charges for luxury wedding car rentals."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Luxury Vehicles",
    "WhyChoosedescription": "All luxury cars are thoroughly cleaned and sanitized before your wedding service to ensure a safe and comfortable experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "Sanavi Travels guarantees punctual pickups and dependable services, making your wedding transportation smooth and hassle-free."
  }
]

}

const faqData = [
  {
    question: 'Do you provide luxury car rentals for weddings in Pune?',
    answer: 'Yes, Sanavi Travels offers premium luxury car rental services specifically for weddings and special occasions in Pune.'
  },
  {
    question: 'What types of luxury cars are available for wedding rentals?',
    answer: 'We have a fleet of high-end luxury cars such as Mercedes, BMW, Audi, and other premium vehicles suitable for wedding use.'
  },
  {
    question: 'Can I customize my wedding luxury car package?',
    answer: 'Yes, we offer customizable rental packages including hourly, half-day, full-day, and multi-day options based on your wedding schedule.'
  },
  {
    question: 'Are chauffeurs provided with the luxury car rentals?',
    answer: 'Yes, professional and uniformed chauffeurs are included with all luxury car rentals.'
  },
  {
    question: 'Is pricing transparent with no hidden charges?',
    answer: 'Absolutely. Our pricing is clear and upfront with no hidden fees.'
  },
  {
    question: 'Are the luxury cars sanitized before the event?',
    answer: 'Yes, every luxury vehicle is thoroughly cleaned and sanitized before your wedding event.'
  },
  {
    question: 'Do you offer luxury car rentals for bridal and groom entry?',
    answer: 'Yes, our luxury cars are ideal for both bride and groom entry as well as family transport during wedding events.'
  },
  {
    question: 'Is customer support available during the wedding rental period?',
    answer: 'Yes, our 24x7 customer support is available throughout your luxury car rental service.'
  },
  {
    question: 'How can I book a luxury wedding car in Pune?',
    answer: 'You can book through our website or contact our customer support team to reserve your luxury car for the wedding.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Desai',
    feedback: 'Booked a luxury car for my wedding in Pune. Impeccable service, professional chauffeur, and a stunning car made the day unforgettable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Joshi',
    feedback: 'Excellent luxury car rental for our wedding. The entire experience was smooth, elegant, and highly satisfactory.',
    rating: 5
  }
];




























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Car on Rent for Wedding in Pune - Sanavi Travels",
  "description": "Book luxury cars for weddings in Pune with Sanavi Travels. Premium AC cars for bridal transport, wedding events, VIP travel, chauffeur-driven journeys, and comfortable, stylish wedding rides.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};





  return (
    <div>


<Helmet>
  <title>
    Luxury Car on Rent for Wedding in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire premium luxury cars for weddings in Pune with Sanavi Travels. Ideal for bridal transport, wedding events, VIP travel, chauffeur-driven journeys, and stylish, comfortable wedding rides."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/71.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxurycaronrentforweddinginpune;